<template>
  <div>
    <router-view :key="'jobCode-' + $route.fullPath" />
  </div>
</template>

<script>
    import JobCodesService from './services/JobCodesService';
    import AddJobCodeComponent from './components/AddJobCodeComponent';

    export default {
        name: "JobsComponent",
        components: {
            AddJobCodeComponent
        },
        data() {
            return {
                showAddJobCodes: false,
                debounce: null
            }
        },
        created() {
            this.getJobCodes();
        },
        methods: {
            getJobCodes() {
                JobCodesService.getJobCodes().then((response) => {
                    this.jobCodes = response;
                }).catch((error) => {
                    console.log(this.label.get('error_loading_job_codes'));
                });
            }
        },
    }
</script>


